import { useEffect, useState } from 'react'
import { apiURL } from '../../../../utilities/URLs'
import { account } from '../../../../classes/Account'
import { refreshAccessToken } from '../../../../utilities/extensions'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { DocumentCenterTab } from '../classes/DocumentCenterTab'

export default function DocumentTabs({ applicationId, selectedType, setSelectedType, prefetchedTabs }) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') ?? ''
  const quarter = searchParams.get('quarter') ?? ''

  const [documentCenterTabs, setDocumentCenterTabs] = useState([])
  const [fetchingTabs, setFetchingTabs] = useState(true)

  useEffect(() => {
    if (Array.isArray(prefetchedTabs)) {
      const tabs = [...prefetchedTabs]
      tabs.push({
        key: 'misc',
        title: 'Miscellaneous',
        description: 'Upload any miscellaneous documents below.'
      })
      setDocumentCenterTabs(tabs)
      setFetchingTabs(false)
      return
    }

    const handleGetDocumentCenterTabs = async () => {
      const documentCenterTabsResponse = await fetch(`${apiURL}/api/applications/${applicationId}/document-center?type=${type}&quarter=${quarter}`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const documentCenterTabsData = await documentCenterTabsResponse.json()
      if (documentCenterTabsData.response.error) {
        if (documentCenterTabsData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetDocumentCenterTabs() : navigate('/', { state: { expired: true } })
        } else
          console.error(documentCenterTabsData.response.error)
      } else {
        let tabs = documentCenterTabsData.response.documentCenterTabs || []
        tabs.push({
          key: 'misc',
          title: 'Miscellaneous',
          description: 'Upload any miscellaneous documents below.'
        })

        setDocumentCenterTabs(tabs)
      }

      setFetchingTabs(false)
    }

    handleGetDocumentCenterTabs()
  }, [applicationId, prefetchedTabs, type, quarter, navigate])

  return (
    <div className='w-full'>
      <div className='w-full overflow-x-auto'>
        {fetchingTabs ? (
          <div className='flex flex-row items-center justify-center gap-2 mt-5'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
            <p className='text-md text-center'>Fetching Tabs...</p>
          </div>
        ) : (
          <div className='flex flex-nowrap md:flex-wrap justify-start md:justify-center border-b border-gray-200 dark:border-slate-700 mb-6 gap-2 mt-10 custom-scrollbar'>
            {documentCenterTabs.map(_tab => {
              const tab = new DocumentCenterTab(_tab)
              return (
                <button
                  key={tab.key}
                  onClick={() => setSelectedType(tab.key)}
                  className={`flex-shrink-0 px-3 py-2 md:px-5 md:py-3 rounded-t-xl whitespace-nowrap transition-colors duration-200 ${selectedType === tab.key
                    ? 'border-b-2 border-ertc-primary text-ertc-primary font-bold bg-gray-50 dark:bg-slate-800'
                    : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-slate-800'
                    }`}
                >
                  {tab.title}
                </button>
              )
            })}
          </div>
        )}
        <p className='mt-2 text-center text-slate-600 dark:text-slate-300 leading-relaxed max-w-3xl mx-auto'>{documentCenterTabs.find(t => t.key === selectedType)?.description}</p>
      </div>
    </div>
  )
}
